import { CourseModule } from "./course-module";
import { CourseScene } from "./course-scene";
import { CoursePage } from "./course-page";
export class CourseContext {
	public courseModule: CourseModule;
	public courseScene: CourseScene;
	public coursePage: CoursePage;
}
